<template>
  <!--线下任务-->
  <el-row class="alltext">
  <!-- <i class="el-icon-back" @click="Jump">返回</i> -->
  <div class="all">
    <h1 class="center">制定入职任务</h1>
    <el-steps :active="active" finish-status="success">
       <el-step title="任务设置"></el-step>
      <el-step title="任务内容"></el-step>
      <el-step title="完成"></el-step>
    </el-steps>
    <div class="con" v-if="active === 0" style="display: flex;">
      <div class="div_left">
        任务主题：<el-input style="width: 27%;" v-model="upload.theme_input" placeholder="请输入任务主题"></el-input> <br />
        任务分类：<el-select v-model="upload.class_value" placeholder="请选择" style="margin-top: 8%;">
                 <el-option
                     v-for="item in info.class_list"
                     :key="item.num"
                     :label="item.name"
                     :value="item.num">
                   </el-option>
                 </el-select> <br />
        任务级别：<el-select v-model="upload.level_value" placeholder="请选择" style="margin-top: 8%;">
                 <el-option
                     v-for="item in info.level_list"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                 </el-select> <br />
          <div v-if="upload.level_value == 1" style="margin-top: 8%;">
           部门选择：<el-button @click="video_click('classlever')">请选择</el-button>
           <span v-if="upload.classlever_list.length !=0"  style="margin-top: 1%; margin-left: 0.625rem;color: blue; cursor: pointer;" @click="selest_click('bm')">
             您选择的
           </span>
           <el-dialog
             title="我选择的部门"
             :visible.sync="selest_bm"
             width="70%">
             <el-table
                 :data=" upload.classlever_list"
                 :height="height.all_height"
                  class="over-tanchuang">
                 <el-table-column
                   prop="name"
                   label="部门列表">
                 </el-table-column>
                 <el-table-column
                   fixed="right"
                   label="操作"
                   width="100">
                   <template slot-scope="scope">
                     <el-button
                     @click.native.prevent="deleteRow(scope.$index, upload.classlever_list,'classlever')"
                       type="text"
                       size="small">
                       移除
                     </el-button>
                   </template>
                 </el-table-column>
               </el-table>
             <span slot="footer" class="dialog-footer">
             <el-button @click="selest_bm = false">关 闭</el-button>
             </span>
           </el-dialog>
            <!-- <div v-if="upload.classlever_list.length !=0" class="filesee" style="margin-top: 2%;">
          您选择的是：
          <el-table
              :data=" upload.classlever_list"
              style="width: 100%"
              max-height="190">
              <el-table-column
                fixed
                prop="name"
                label="部门列表"
                width="200">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="100">
                <template slot-scope="scope">
                  <el-button
                  @click.native.prevent="deleteRow(scope.$index, upload.classlever_list,'classlever')"
                    type="text"
                    size="small">
                    移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
        </div> -->
       </div>
        培训说明：<el-input style="width: 80%; margin-top: 8%;" type="textarea" 	 :autosize="{ minRows: 2, maxRows:999}" v-model="upload.explain_input" placeholder="请输入内容"></el-input> <br />
      </div>
      <div class="div_right">
        培训时间：<el-input style="width: 27%;margin-top: 8%;" v-model="upload.day" placeholder="培训时长"></el-input>天 <br />
        电子签名：<el-select v-model="upload.autograph_value" placeholder="请选择" style="margin-top:8%;">
                 <el-option
                     v-for="item in info.autograph_list"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                 </el-select> <br />
        培训结果确认：<el-select v-model="upload.result_value" placeholder="请选择" style="margin-top:8%;">
                 <el-option
                     v-for="item in info.result_list"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                 </el-select> <br />
          </div>
                 <div class="con-button">
                  <el-button @click="next(1)">下一步</el-button>
                 </div>
    </div>
    <div class="con" v-if="active === 1" style="display: flex;">
      <div class="div_left">
        任务内容：<el-select v-model="upload.content_value" placeholder="请选择" style="margin-top:8%;" @change='rwcontent_click'>
                 <el-option
                     v-for="item in info.content_list"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                 </el-select> <br />
      <div v-if="upload.content_value=='0'" style="margin-top: 8%;">
        文档学习：<el-button @click="video_click('file')">请选择</el-button>
        <span v-if="upload.file_list.length !=0"  style="margin-top: 1%; margin-left: 0.625rem;color: blue; cursor: pointer;" @click="selest_click('word')">
          您选择的
        </span>
        <el-dialog
          title="我选择的学习文档(必填)"
          :visible.sync="selest_word"
          width="70%">
          <el-table
              :data=" upload.file_list"
              :height="height.tree_height"
               class="over-tanchuang">
              <el-table-column
                fixed
                prop="name"
                label="文档名">
              </el-table-column>
              <el-table-column
                    label="阅读时间(秒)"
                    width="180"
                    prop="time"
                    >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.time" type="number" maxlength="20" placeholder="请输入时间(秒)" size="mini" />
                    </template>
                  </el-table-column>
              <el-table-column
              width="100"
                label="操作">
                <template slot-scope="scope">
                  <el-button
                  @click.native.prevent="deleteRow(scope.$index, upload.file_list,'file')"
                    type="text"
                    size="small">
                    移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="file_time()">确 定</el-button>
          </span>
        </el-dialog>
        <!-- <div v-if="upload.file_list.length !=0" class="filesee" style="margin-top: 1%;">
          您选择的是：
          <el-table
              :data=" upload.file_list"
              style="width: 100%"
              max-height="190">
              <el-table-column
                fixed
                prop="name"
                label="文档名"
                width="200">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="100">
                <template slot-scope="scope">
                  <el-button
                  @click.native.prevent="deleteRow(scope.$index, upload.file_list,'file')"
                    type="text"
                    size="small">
                    移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
        </div> -->
      </div>
      <div v-if="upload.content_value=='1'"  >
        资&nbsp;源&nbsp;包： <el-select v-model="upload.pack_value"  multiple collapse-tags  placeholder="请选择" style="margin-top:8%;">
                 <el-option
                     v-for="item in info.pack_list"
                     :key="item.num"
                     :label="item.name"
                     :value="item.num">
                   </el-option>
                 </el-select> <br />
                药知视频：&nbsp;<el-button style="margin-top: 8%;"  @click="video_click('yz')">请选择</el-button>
                <span v-if="upload.yzvideo_list.length !=0"  style="margin-left: 10px;color: blue; cursor: pointer;" @click="selest_click('yz')">
                  您选择的
                </span>
                  <el-dialog
                    title="我选择的药知视频"
                    :visible.sync="selest_yz"
                    width="70%"
                    >
                    <el-table
                        :data=" upload.yzvideo_list"
                        :height="height.tree_height"
                         class="over-tanchuang"
                        >
                        <el-table-column
                          fixed
                          prop="name"
                          label="药知视频名称">
                        </el-table-column>
                        <el-table-column
                        width="100"
                          label="操作">
                          <template slot-scope="scope">
                            <el-button
                            @click.native.prevent="deleteRow(scope.$index, upload.yzvideo_list,'yzvideo')"
                              type="text"
                              size="small">
                              移除
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    <span slot="footer" class="dialog-footer">
                    <el-button @click="selest_yz = false">关 闭</el-button>
                    </span>
                  </el-dialog>
                  <br />
                <!-- <div v-if="upload.yzvideo_list.length !=0" class="filesees">
                  您选择的是：
                  <el-table
                      :data=" upload.yzvideo_list"
                      style="width: 100%"
                      max-height="190">
                      <el-table-column
                        fixed
                        prop="name"
                        label="药知视频名称"
                        width="200">
                      </el-table-column>
                      <el-table-column
                        fixed="right"
                        label="操作"
                        width="100">
                        <template slot-scope="scope">
                          <el-button
                          @click.native.prevent="deleteRow(scope.$index, upload.yzvideo_list,'yzvideo')"
                            type="text"
                            size="small">
                            移除
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                </div> -->
                内部视频：&nbsp;<el-button style="margin-top: 8%;"  @click="video_click('nb')">请选择</el-button>
                <span v-if="upload.nbvideo_list.length !=0" style="margin-left: 0.625rem; color: blue; cursor: pointer;" @click="selest_click('nb')">您选择的</span>
                <el-dialog
                  title="我选择的"
                  :visible.sync="selest_nb"
                  width="70%">
                  <el-table
                      :data=" upload.nbvideo_list"
                      :height="height.tree_height"
                       class="over-tanchuang"
                     >
                      <el-table-column
                        fixed
                        prop="name"
                        label="内部视频名称">
                      </el-table-column>
                      <el-table-column
                      width="100"
                        label="操作">
                        <template slot-scope="scope">
                          <el-button
                          @click.native.prevent="deleteRow(scope.$index, upload.nbvideo_list,'nbvideo')"
                            type="text"
                            size="small">
                            移除
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  <span slot="footer" class="dialog-footer">
                  <el-button @click="selest_nb = false">关 闭</el-button>
                  </span>
                </el-dialog>
                <!-- <div v-if="upload.nbvideo_list.length !=0" class="filesees">
                  您选择的是：
                  <el-table
                      :data=" upload.nbvideo_list"
                      style="width: 100%"
                      max-height="190">
                      <el-table-column
                        fixed
                        prop="name"
                        label="内部视频名称"
                        width="200">
                      </el-table-column>
                      <el-table-column
                        fixed="right"
                        label="操作"
                        width="100">
                        <template slot-scope="scope">
                          <el-button
                          @click.native.prevent="deleteRow(scope.$index, upload.nbvideo_list,'nbvideo')"
                            type="text"
                            size="small">
                            移除
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                </div> -->
      </div>
      <div v-if="upload.content_value=='2'" >
       题库类型选择：<el-select v-model="upload.tktype_value" placeholder="请选择" style="margin-top:8%;"  @change='tikuleixing_click'>
               <el-option
                   v-for="item in info.tktype_list"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
                 </el-option>
               </el-select> <br />
               <div  style="margin-top:8%;">
       题库选择：<el-button @click="video_click('tiku')">请选择</el-button>
       <span v-if="upload.tkshow_list.length !=0"  style="margin-top: 2%; margin-left: 0.625rem;color: blue; cursor: pointer;" @click="selest_click('tk')">您选择的是</span>
               <el-dialog
                 title="我选择的"
                 :visible.sync="selest_tk"
                 width="70%">
                 <el-table
                     :data="upload.tkshow_list"
                     :height="height.tree_height"
                      class="over-tanchuang">
                     <el-table-column
                       prop="name"
                       label="题库">
                     </el-table-column>
                     <el-table-column
                     width="100"
                       label="操作">
                       <template slot-scope="scope">
                         <el-button
                         @click.native.prevent="deleteRow(scope.$index, upload.tkshow_list,'tiku')"
                           type="text"
                           size="small">
                           移除
                         </el-button>
                       </template>
                     </el-table-column>
                   </el-table>
                 <span slot="footer" class="dialog-footer">
                 <el-button @click="selest_tk = false">关 闭</el-button>
                 </span>
               </el-dialog>
                  <!-- <div v-if="upload.tkshow_list.length !=0" class="filesee" style="margin-top: 2%;">
                 您选择的是：
                 <el-table
                     :data="upload.tkshow_list"
                     style="width: 100%"
                     max-height="190">
                     <el-table-column
                       fixed
                       prop="name"
                       label="题库"
                       width="200">
                     </el-table-column>
                     <el-table-column
                       fixed="right"
                       label="操作"
                       width="100">
                       <template slot-scope="scope">
                         <el-button
                         @click.native.prevent="deleteRow(scope.$index, upload.tkshow_list,'tiku')"
                           type="text"
                           size="small">
                           移除
                         </el-button>
                       </template>
                     </el-table-column>
                   </el-table>
               </div> -->
                </div>

      </div>
      </div>
      <div class="div_right">
        <div v-if="upload.content_value!='2'">
          是否考试：<el-select v-model="upload.exa_value" placeholder="请选择" style="margin-top:8%;">
                   <el-option
                       v-for="item in info.exa_list"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
                     </el-option>
                   </el-select> <br />
        </div>
         <div v-if="upload.exa_value ==1 || upload.content_value =='2'">
           题   目   数：&nbsp;<el-input style="width: 50%; margin-top: 8%;" v-model="upload.tmnum_input" placeholder="请输入内容"></el-input> <br />
           及   格   分：&nbsp;<el-input style="width: 50%; margin-top: 8%;" v-model="upload.pass_input" placeholder="请输入内容"></el-input> <br />
           考核时长：<el-input style="width: 50%;margin-top: 8%;" v-model="upload.exatime_input" placeholder="请输入内容"></el-input> 分钟<br />
           考核次数(包含补考次数)：<el-select v-model="upload.num_value" placeholder="请选择" style="margin-top:8%;">
                    <el-option
                        v-for="item in info.num_list"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select> <br />

      </div>

       </div>
       <div class="con-button">
        <el-button @click="back(0)">上一步</el-button>
         <el-button @click="train_save()">保存</el-button>
       </div>
    </div>
    <div class="con" v-if="active === 3">
        <div class="okclass" v-show="true">
          <div style="text-align:center;"><h3>保存成功</h3><br />
          <img  width="50%" src="../../../../assets/TaskAdd_ok.jpg"  />
          </div>
         </div>
         <div class="okclass" v-show="false">
           <div style="text-align:center;"><h3>保存失败</h3><br />
           <img  width="50%" src="../../../../assets/TaskAdd_fail.jpg"  />
           </div>
          </div>
      <div class="con-button">
       <el-button @click="back(1)">上一步</el-button>
        <el-button @click="Jump()">完成</el-button>
      </div>
      </div>
    <!-- <div class="con" v-if="active === 2" style="display: flex;  ">
        <div class="ercitankuang_left">
           <p style="margin-top: 10px; margin-bottom: 20px;"><span style=" margin-left:10px;">请选择员工</span>
           <span style="position:absolute;  right: 5%;">
          <el-button   type="danger" icon="el-icon-delete" circle @click="removeper()"></el-button>
          <el-button type="success"  icon="el-icon-check" circle  @click="per_click"></el-button>
          </span></p>
         <el-input  v-model="per_value" placeholder="请输入内容"></el-input> <br />
          <el-tree
               show-checkbox
               :data="info.per_list"
               ref="treeper"
               node-key="num"
               :filter-node-method="filterNode"
               :default-checked-keys="setup.mr_xz_key"
              :props="setup.defaultProps">
          </el-tree>
        </div>
        <div class="ercitankuang_content"></div>
        <div class="ercitankuang_right">
          您选择的员工是：
         <p v-for="(item,key) in upload.xzper_list">{{item.name}}</p >
        </div>
      <div class="con-button">
       <el-button @click="back(1)">上一步</el-button>
        <el-button @click="train_save()">保存</el-button>
      </div>
      </div> -->
      <br /> </div>

    </div>

          <!-- <el-dialog :title=setup.video_title  :visible.sync="setup.video_show" :width="dialog">
           <div style="display: flex;  ">
            <div class="ercitankuang_left" :style="{height:height.all_height}">
              <p style="margin-top: 10px;"><span style=" margin-left:10px;"></span>
              <span style="position:absolute;  right: 5%;">
              <el-button   type="danger" icon="el-icon-delete" circle @click="remove()"></el-button>
              <el-button type="success"  icon="el-icon-check" circle  @click="videofileok_click"></el-button>
              </span>
              </p>
         <el-input  style="margin-top: 9px;" v-model="videofile_value" placeholder="请输入内容"></el-input> <br />
              <el-tree
              :style="{height:height.tree_height}"
              class="over_tree"
                show-checkbox
                :check-strictly="checkStrictly"
               :data="setup.videofileall_list"
               ref="tree"
               node-key="num"
               @check="check_group"
               :filter-node-method="filterNode"
               :default-checked-keys="setup.morenkey"
               :props="setup.defaultProps">
          </el-tree>
           </div>
        <div class="ercitankuang_content"></div>
        <div class="ercitankuang_right" :style="{height:height.all_height}">
          您选择的是：
          <p v-for="(item,key) in  setup.xzvideofile_list">{{item.name}}</p>
        </div>
      </div>
   <div slot="footer" class="dialog-footer">
     <el-button v-if="dialog=='80%'"  @click="dialog_click('da')">全 屏</el-button>
     <el-button v-else @click="dialog_click('xiao')">缩 小</el-button>
     <el-button @click="setup.video_show = false;">取 消</el-button>
     <el-button type="primary" @click="determine()">确 定</el-button>
      </div>
  </el-dialog> -->
  <el-dialog :title=setup.video_title  :visible.sync="setup.video_show" :width="dialog">
           <div style="display: flex;">
            <div class="ercitankuang_left" :style="{height:height.all_height}">
              <p style="margin-top: 10px;"><span style=" margin-left:10px;"></span>
              <span style="position:absolute;  right: 5%;">
              <el-button   type="danger" icon="el-icon-delete" circle @click="remove()"></el-button>
              <el-button type="success"  icon="el-icon-check" circle  @click="videofileok_click"></el-button>
              </span>
              </p>
               <el-input  style="margin-top: 9px;" v-model="videofile_value" placeholder="请输入内容"></el-input> <br />
              <el-row >
                <el-tree
                :style="{height:height.tree_height}"
                class="over_tree"
                      show-checkbox
                      :check-strictly="checkStrictly"
                     :data="setup.videofileall_list"
                     ref="tree"
                     node-key="num"
                     @check="check_group"
                     :filter-node-method="filterNode"
                     :default-checked-keys="setup.morenkey"
                     :render-content="renderContent"
                     :props="setup.defaultProps">
                </el-tree>
              </el-row>
           </div>
            <div class="ercitankuang_content"></div>
            <div class="ercitankuang_right" :style="{height:height.all_height}">
              您选择的是：
              <!-- <div v-html="companyee_choiced.html"></div> -->
              <p v-for="(item,key) in  setup.xzvideofile_list">{{item.name}}</p>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
             <el-button v-if="dialog=='80%'"  @click="dialog_click('da')">全 屏</el-button>
             <el-button v-else @click="dialog_click('xiao')">缩 小</el-button>
             <el-button @click="setup.video_show = false;">取 消</el-button>
             <el-button type="primary" @click="determine()">确 定</el-button>
          </div>
  </el-dialog>
  <el-dialog
    title="文档阅读时间(必填)"
    :visible.sync="selest_file_time"
    :closeOnClickModal='false'
    width="70%">
    <el-table
        :data=" upload.file_list"
        :height="height.tree_height"
         class="over-tanchuang">
        <el-table-column
          fixed
          prop="name"
          label="文档名">
        </el-table-column>
        <el-table-column
              label="阅读时间(秒)"
              width="180"
              prop="time"
              >
              <template slot-scope="scope">
                  <el-input v-model="scope.row.time" type="number" maxlength="20" placeholder="请输入时间(秒)" size="mini" />
              </template>
            </el-table-column>
        <el-table-column
        width="100"
          label="操作">
          <template slot-scope="scope">
            <el-button
            @click.native.prevent="deleteRow(scope.$index, upload.file_list,'file')"
              type="text"
              size="small">
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="file_time()">确 定</el-button>
    </span>
  </el-dialog>
  </div>

  </el-row>
</template>

<script>
  export default {
    watch: {
         per_value(val) {
           // 根据关键词过滤
           this.$refs.treeper.filter(val);
         },
         videofile_value(val){
           // 根据关键词过滤
           this.$refs.tree.filter(val);
         },
       },


    name: 'App',
    data() {
      return {
        height:{
          all_height:'',
          tree_height:'',
          yuangong_height:''
        },
        dialog:'80%',
        selest_yz:false,//确认选择的药知视频
        selest_nb:false,
        selest_tk:false,
        selest_word:false,
        selest_bm:false,
        selest_file_time:false,
      checkStrictly:true,
      videofile_value:'',//视频文档弹框
      per_value:'',//选择人员
      active: 0,
      setup:{
        classlever_value:'',//部门级别选择
        tikuxuanze_value:'',//题库选择
        morenkey:[],//默认展开的树
        xzvideofile_list:[],//选择文档视频
        video_title:'',//视频弹框标题
        video_show:false,//视频文档显示
        videofile_type:'',//视频文档类型
        videofileall_list:'',//视频文档list
        defaultProps: {
          children: 'children',
          label: 'name',
        },

      },
      info:{
       classlever_list: [],
        tikuxuanze_list: [],
        yztiku_list:[],
        nbtiku_list:[],
        class_list: [],
        level_list:[{
                  value: '0',
                  label: '企业级别'
                },  {
                  value: '1',
                  label: '部门级别'
                },],
        content_list:[{
                  value: '0',
                  label: '文档学习'
                }, {
                  value: '1',
                  label: '视频观看'
                }, {
                  value: '2',
                  label: '独立考试'
                }],
         tktype_list:[{
                  value: '0',
                  label: '药知题库'
                }, {
                  value: '1',
                  label: '内部题库'
                },],
         exa_list:[
           {value:'0',
            label:'否'
           }, {value:'1',
            label:'是'
           }
         ],
         autograph_list:[
           {value:'0',
            label:'否'
           }, {value:'1',
            label:'是'
           }
         ],
         result_list:[
           {value:'0',
            label:'否'
           }, {value:'1',
            label:'是'
           }
         ],
         num_list:[
           {value:'0',
            label:'跟随系统'
           }, {value:'1',
            label:'1'
           }, {value:'2',
            label:'2'
           },{value:'3',
            label:'3'
           },{value:'4',
            label:'4'
           },{value:'5',
            label:'5'
           },
         ],
        per_list:[],
        nbvideo_list:[],
        yzvideo_list:[],
        file_list:[],
       pack_list:[],
      },
     upload:{
      class_value: '' ,//任务分类
      theme_input:'',//任务主题
      explain_input:'',//培训说明
      level_value:'0',//任务级别
      content_value:'0',//任务内容
      exa_value:'0',//是否考试
      autograph_value:'0',//是否电子签名
      result_value:'0',//任务确认
      num_value:'1',//考核次数
      time_picker:'',//日历选择器
      tktype_value:'0',//题库类型 选择
      nbtk_list:[],//题库选择
      yztk_list:[],//题库选择
      tkshow_list:[],//显示题库
      xzper_list:[],//选择人员
      tmnum_input:'',//题目数
      pass_input:'',//及格分
      exatime_input:'',//考试时间
      pack_value:[],//资源包
      yzvideo_list:[],//选择药知视频
      nbvideo_list:[],//选择内部视频
      file_list:[],//选择文档
      classlever_list:[],//部门级别
      train_type:'1',
      day:''
     },
   }
    },
    components: {

    },
    mounted: function() {
     this.get_info()
     this.height.all_height=window.innerHeight *0.6  + 'px'
     // this.height.yuangong_height=window.innerHeight *0.6  - 80 + 'px'
     this.height.tree_height=window.innerHeight *0.6 - 120 + 'px'
    },

    methods: {
      renderContent(h, { node }) {
        return (
          <span >
                <span  style=" display: inline-block;white-space: nowrap;width: 100%;overflow: hidden;text-overflow:ellipsis;" title={node.data.name}>{node.data.name}</span>
          </span>)
      },
      file_time(){
          let _this=this
          if(_this.upload.file_list.length==0){
            _this.selest_file_time=false
            _this.setup.video_show = false;
            _this.selest_word=false
          }else{
            for(let i=0;i<_this.upload.file_list.length;i++){
              if( !_this.upload.file_list[i].hasOwnProperty('time') || _this.upload.file_list[i].time==""){
                _this.$message.error("问答的阅读时间必填");
                return
              }
              if(i+1==_this.upload.file_list.length){
                _this.selest_file_time=false
                _this.setup.video_show = false;
                _this.selest_word=false
              }

            }
          }


      },
      dialog_click(type){

        if(type=='da'){
          this.dialog='100%'
        }else{
          this.dialog='80%'
        }
        // this.height.all_height=window.innerHeight *0.7  + 'px'
        // this.height.tree_height=window.innerHeight *0.7 - 120 + 'px'
      },
      selest_click(type){
        if(type=='yz'){
          this.selest_yz=true
        }else if(type=='nb'){
          this.selest_nb=true
        }else if(type=='tk'){
          this.selest_tk=true
        }else if(type=='word'){
          this.selest_word=true
        }else{
          this.selest_bm=true
        }
      },
      get_info(){
        let _this=this;
        if(_this.$route.query.num && _this.$route.query.num!=''){
          _this.upload.num=_this.$route.query.num
          _this.axios.get("/v2/c_train/get_train_info_edit",{params:{'num':_this.$route.query.num,'type':'online'}}).then(function (res) {
            if (res.status == "200") {
              if (res.data.code == "1") {
                _this.upload.theme_input=res.data.data.name
                _this.upload.class_value=res.data.data.t_id
                _this.upload.level_value=res.data.data.role_type
                _this.upload.classlever_list=res.data.data.section
                _this.upload.explain_input=res.data.data.info
                _this.upload.time_picker= [res.data.data.start_time,
                 res.data.data.end_time]
                _this.upload.day= res.data.data.day
                _this.upload.autograph_value=res.data.data.idcard_status
                _this.upload.result_value=res.data.data.confirm_status
                _this.upload.content_value=res.data.data.type
                _this.upload.file_list=res.data.data.file
                _this.upload.pack_value=[]
                _this.upload.yzvideo_list=res.data.data.video.public
                _this.upload.nbvideo_list=res.data.data.video.local
                if(res.data.data.subject=='0' && res.data.data.subject_score=='0' && res.data.data.exam_time=='0'){
                  _this.upload.exa_value= '0'
                }else{
                  _this.upload.exa_value= '1'
                }
                _this.upload.tktype_value=res.data.data.subject_type[0]
                if(res.data.data.subject_type[0]=='0'){
                  _this.upload.yztk_list[0]=res.data.data.subject_type[1]
                  _this.upload.tkshow_list=_this.upload.yztk_list
                }
                if(res.data.data.subject_type[0]=='1'){
                  _this.upload.nbtk_list[0]=res.data.data.subject_type[1]
                  _this.upload.tkshow_list=_this.upload.nbtk_list
                }
                _this.upload.tmnum_input=res.data.data.subject//题目数
                _this.upload.pass_input=res.data.data.subject_score//及格分
                _this.upload.exatime_input=res.data.data.exam_time//考试时长
                _this.upload.num_value=res.data.data.exam_num//考核次数
                _this.upload.xzper_list=res.data.data.companyee
              } else {
                _this.$message.error("服务器内部错误");
              }
            } else {
              _this.$message.error("服务器内部错误");
            }
          });
        }else{
          _this.upload.num=''
          _this.$message.success('新增');
        }
        _this.get_train_type()
      },

      get_train_type(){
        let _this=this
        _this.axios.get('/v2/c_train/get_train_type',{params:{'page':'1','limit':'9999'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.info.class_list=res.data.data.data
              _this.get_section()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });

      },

      get_section(){
        let _this = this;
        _this.axios.get("/v2/c_section/get_list").then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.info.classlever_list=res.data.data
              _this.get_train_file()
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      get_train_file(){
        let _this = this;
        _this.axios.get("/v2/c_train/get_train_file").then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.info.file_list=res.data.data
              _this.get_train_resource()
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      get_train_resource(){
        let _this = this;
        _this.axios.get("/v2/c_train/get_train_resource",{params:{'page':'1','limit':'999','type':'0','push':'1'}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
               _this.info.pack_list=res.data.data.data
               _this.get_train_video()
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      // get_train_video(){
      //   let _this=this
      //   _this.axios.get("/v2/c_train/get_train_video").then(function (res) {
      //     if (res.status == "200") {
      //       if (res.data.code == "1") {
      //         _this.info.yzvideo_list=res.data.data.public
      //         _this.info.nbvideo_list=res.data.data.local
      //         _this.get_subject()
      //       } else {
      //         _this.$message.error(res.data.msg);
      //       }
      //     } else {
      //       _this.$message.error("服务器内部错误");
      //     }
      //   });
      // },

      get_train_video(){
              let _this=this
              let show=false
              _this.axios.get("/v2/c_train/get_train_video").then(function (res) {
                if (res.status == "200") {
                  if (res.data.code == "1") {
                    _this.info.yzvideo_list=res.data.data.public
                    _this.info.nbvideo_list=res.data.data.local
                    show=true
                    let list=_this.info.yzvideo_list
                    if(show){
                      for(let i=0;i<list.length;i++){
                        if(list[i].hasOwnProperty('children')){
                          for(let j=0;j<list[i].children.length;j++){
                            if(list[i].children[j].hasOwnProperty('children')){
                              for(let q=0;q<list[i].children[j].children.length;q++){
                                if(list[i].children[j].children[q].hasOwnProperty('children')){
                                  for(let w=0;w<list[i].children[j].children[q].children.length;w++){
                                     let aa=list[i].children[j].children[q].children[w].subject_num.split('_')
                                     let bb=aa[0]*1+aa[2]*1
                                         list[i].children[j].children[q].name =  list[i].children[j].children[q].name+'（'+bb+'题)'
                                        break
                                  }
                                }else{
                                 let aa=list[i].children[j].children[q].subject_num.split('_')
                                 let bb=aa[0]*1+aa[2]*1
                                 list[i].children[j].name =  list[i].children[j].name+'（'+bb+'题)'
                                  break
                                }
                              }
                            }else{
                             let aa=list[i].children[j].subject_num.split('_')
                             let bb=aa[0]*1+aa[2]*1
                             list[i].name =list[i].name+'（'+bb+'题)'
                              break
                            }
                          }
                        }
                      }
                      _this.info.yzvideo_list=list
                    }
                    _this.get_subject()
                  } else {
                    _this.$message.error(res.data.msg);
                  }
                } else {
                  _this.$message.error("服务器内部错误");
                }
              });
            },

      get_subject(){
        let _this=this
        _this.axios.get('/v2/c_resource/get_video_type',{params:{type:0}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.info.yztiku_list=res.data.data
              // _this.upload.tkshow_list=res.data.data
              _this.get_subject_self()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      get_subject_self(){
        let _this=this
        _this.axios.get('/v2/c_resource/get_video_type').then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
               _this.info.nbtiku_list=res.data.data
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

     train_save(){
       let _this=this
       _this.axios.post("/v2/c_train/train_save",{data:_this.upload}).then(function (res) {
         if (res.status == "200") {
           if (res.data.code == "1"){
             _this.next(3)
           } else {
             _this.$message.error(res.data.msg);
           }
         } else {
           _this.$message.error("服务器内部错误");
         }
       });
     },
    check_group(a,b){
        if(this.setup.videofile_type=='tiku'){
         if(b.checkedKeys.length >0){
           this.$refs.tree.setCheckedKeys([a.num])
         }
        }
      },

     tikuleixing_click(){
        let _this=this;
       if(_this.upload.tktype_value == '0'){
       _this.upload.tkshow_list=_this.upload.yztk_list
       }else if(_this.upload.tktype_value == '1'){
       _this.upload.tkshow_list=_this.upload.nbtk_list
       }
     },
      rwcontent_click(){
        let _this=this;
        _this.upload.exa_value='0'
        if(_this.upload.content_value =='2'){
          _this.upload.exa_value='1'
          if(_this.upload.tktype_value == '0'){
             _this.upload.tkshow_list=_this.upload.yztk_list;
          }else if(_this.upload.tktype_value == '1'){
             _this.upload.tkshow_list=_this.upload.nbtk_list;
          }
        }
      },

      //移除文档视频，
       deleteRow(index, rows,type) {
         let _this=this
         if(type=='file'){
            _this.$confirm('确认取消所选？').then(_ => {
              rows.splice(index, 1);
              for(let i=0;i<_this.upload.file_list.length;i++){
                if(_this.upload.file_list[i].num==rows.num){
                  _this.upload.file_list.splice(i,1);

                }
              }

            })
            .catch(_ => {});
         }else if(type=='yzvideo'){
          _this.$confirm('确认取消所选分类？').then(_ => {
            rows.splice(index, 1);
            for(let i=0;i<_this.upload.yzvideo_list.length;i++){
              if(_this.upload.yzvideo_list[i].num==rows.num){
                _this.upload.yzvideo_list.splice(i,1);
              }
            }

          })
          .catch(_ => {});
         }else if(type=='nbvideo'){
         _this.$confirm('确认取消所选分类？').then(_ => {
           rows.splice(index, 1);
           for(let i=0;i<_this.upload.nbvideo_list.length;i++){
             if(_this.upload.nbvideo_list[i].num==rows.num){
               _this.upload.nbvideo_list.splice(i,1);
             }
           }

         })
         .catch(_ => {});
         }else if(type=='classlever'){
         _this.$confirm('确认取消所选分类？').then(_ => {
           rows.splice(index, 1);
           for(let i=0;i<_this.upload.classlever_list.length;i++){
             if(_this.upload.classlever_list[i].num==rows.num){
               _this.upload.classlever_list.splice(i,1);
             }
           }

         })
         .catch(_ => {});
         }else if(type=='tiku'){
         _this.$confirm('确认取消所选分类？').then(_ => {
           rows.splice(index, 1);
           for(let i=0;i<_this.upload.tkshow_list.length;i++){
             if(_this.upload.tkshow_list[i].num==rows.num){
               _this.upload.tkshow_list.splice(i,1);
             }
           }

         })
         .catch(_ => {});}
            },
      //确定
      determine(){
        let _this=this;
        if(_this.setup.videofile_type=='yz'){
          _this.setup.video_show = false;
        _this.upload.yzvideo_list=_this.setup.xzvideofile_list;
         }else if(_this.setup.videofile_type=='nb'){
           _this.setup.video_show = false;
          _this.upload.nbvideo_list=_this.setup.xzvideofile_list;
         }else if(_this.setup.videofile_type=='file'){
           _this.selest_file_time=true
           _this.upload.file_list=_this.setup.xzvideofile_list;
         }else if(_this.setup.videofile_type=='classlever'){
           _this.setup.video_show = false;
            _this.upload.classlever_list=_this.setup.xzvideofile_list;
         }else if(_this.setup.videofile_type=='tiku'){
           _this.setup.video_show = false;
           if(_this.upload.tktype_value =='0'){
              _this.upload.yztk_list=_this.upload.tkshow_list=_this.setup.xzvideofile_list;
           }else{
             _this.upload.nbtk_list=_this.upload.tkshow_list=_this.setup.xzvideofile_list;
           }
        }
      },
      //取消按钮
      remove(){
        let _this=this;
        _this.setup.xzvideofile_list=[];
         _this.$nextTick(function () {
                //Dom更新完毕
                this.$refs.tree.setCheckedKeys([]);
              });
      },
      removeper(){
        let _this=this;
        _this.upload.xzper_list=[];
         _this.$nextTick(function () {
                //Dom更新完毕
                this.$refs.treeper.setCheckedKeys([]);
              });
      },
      //文档视频弹框确定
      videofileok_click(){
        let _this=this;
        let a=this.$refs.tree.getCheckedNodes();
        _this.setup.xzvideofile_list=[];
        let j=0;
        if(_this.setup.videofile_type=='classlever'){
         for(let i=0;i<a.length;i++){
           _this.$set(_this.setup.xzvideofile_list,j,a[i])
           j++;
         }
        }else if(_this.setup.videofile_type=='tiku'){
          for(let i=0;i<a.length;i++){
            _this.$set(_this.setup.xzvideofile_list,j,a[i])
            j++;
          }
        }
        else{
         for(let i=0;i<a.length;i++){
           if(a[i].hasOwnProperty('status')){
             _this.$set(_this.setup.xzvideofile_list,j,a[i])
             j++;
           }
         }
        }
      },
      //文档视频弹框
      video_click(type){
       let _this=this;
       _this.dialog='80%'
       if(type=='tiku'){
         if(_this.upload.tktype_value==''){
           alert("请选择题库类型")
           return
         }
       }
       _this.setup.video_show=true;
       _this.setup.morenkey=[];
       _this.setup.xzvideofile_list=[];
        _this.videofile_value='';
        _this.$nextTick(function () {
               //Dom更新完毕
               this.$refs.tree.setCheckedKeys([]);
             });
        if(type=='yz'){
          _this.checkStrictly=false;
         if(_this.upload.yzvideo_list.length != 0){
           let list=[];
           _this.setup.xzvideofile_list=_this.upload.yzvideo_list;
           for(let i=0;i<_this.upload.yzvideo_list.length;i++){
             _this.setup.morenkey.push(_this.upload.yzvideo_list[i]);
             list.push(_this.upload.yzvideo_list[i].num);
           }
           _this.$nextTick(function () {
                  //Dom更新完毕
                  this.$refs.tree.setCheckedKeys(list);
                });
         }
         _this.setup.videofileall_list=_this.info.yzvideo_list;
         _this.setup.video_title="药知视频";
         _this.setup.videofile_type='yz';
       }else if(type=='nb'){
        _this.checkStrictly=false;
        if(_this.upload.nbvideo_list.length != 0){
          let list=[];
           _this.setup.xzvideofile_list=_this.upload.nbvideo_list;
          for(let i=0;i<_this.upload.nbvideo_list.length;i++){
            _this.setup.morenkey.push(_this.upload.nbvideo_list[i]);
            list.push(_this.upload.nbvideo_list[i].num);
          }
          _this.$nextTick(function () {
                 //Dom更新完毕
                 this.$refs.tree.setCheckedKeys(list);
               });
        }
          _this.setup.videofileall_list=_this.info.nbvideo_list;
          _this.setup.video_title="内部视频";
          _this.setup.videofile_type='nb';
       }else if(type=='file'){
         _this.checkStrictly=false;
         if(_this.upload.file_list.length != 0){
           let listfile=[];
         _this.setup.xzvideofile_list=_this.upload.file_list;
           for(let i=0;i<_this.upload.file_list.length;i++){
             _this.setup.morenkey.push(_this.upload.file_list[i]);
             listfile.push(_this.upload.file_list[i].num)
           }
           _this.$nextTick(function () {
                  //Dom更新完毕
                  this.$refs.tree.setCheckedKeys(listfile);
                });
         }
         _this.setup.videofileall_list=_this.info.file_list;
          _this.setup.video_title="文档选择";
          _this.setup.videofile_type='file';
       }else if(type=='classlever'){
        _this.checkStrictly=true;
        if(_this.upload.classlever_list.length != 0){
          let list=[];
           _this.setup.xzvideofile_list=_this.upload.classlever_list;
          for(let i=0;i<_this.upload.classlever_list.length;i++){
            _this.setup.morenkey.push(_this.upload.classlever_list[i]);
            list.push(_this.upload.classlever_list[i].num);
          }
          _this.$nextTick(function () {
                 //Dom更新完毕
                 this.$refs.tree.setCheckedKeys(list);
               });
        }
          _this.setup.videofileall_list=_this.info.classlever_list;
          _this.setup.video_title="部门列表";
          _this.setup.videofile_type='classlever';
       }else if(type=='tiku'){
        _this.checkStrictly=true;
        if(_this.upload.tktype_value == '0'){
           _this.upload.tkshow_list=_this.upload.yztk_list;
        }else{
           _this.upload.tkshow_list=_this.upload.nbtk_list;
        }
        if(_this.upload.tkshow_list.length != 0){
          let list=[];
           _this.setup.xzvideofile_list=_this.upload.tkshow_list;
          for(let i=0;i<_this.upload.tkshow_list.length;i++){
            list.push(_this.upload.tkshow_list[i].num);
          }
          _this.$nextTick(function () {
                 //Dom更新完毕
                 this.$refs.tree.setCheckedKeys(list);
               });
        }
        if(_this.upload.tktype_value=='0'){
           _this.setup.videofileall_list=_this.info.yztiku_list;
        }else if(_this.upload.tktype_value=='1'){
          _this.setup.videofileall_list=_this.info.nbtiku_list;
        }
          _this.setup.video_title="题库选择";
          _this.setup.videofile_type='tiku';

       }
      },
       filterNode(value, data) {
         if (!value) return true;
          return data.name.indexOf(value) !== -1;
            },
      Jump(){
        this.$router.push({path:'/entry'});
      },
     next(num){
      this.active= num;
      if(num==2){
        if(this.upload.xzper_list.length !=0){
          let list=[];
          for(let i=0;i<this.upload.xzper_list.length;i++){
             list.push(this.upload.xzper_list[i].num);
          }
          this.$nextTick(function () {
                 //Dom更新完毕
                 this.$refs.treeper.setCheckedKeys(list);
               });
        }
      }
     },
     back(num){
      this.active= num;
     },
     per_click() {
            let a=this.$refs.treeper.getCheckedNodes();
            this.upload.xzper_list=[];
            let j=0;
            for(let i=0;i<a.length;i++){
              if(a[i].hasOwnProperty('s_id')){
                this.$set(this.upload.xzper_list,j,a[i])
                j++;
              }
            }
          },
    }
  }
</script>

<style scoped>
  .okclass{
    display: flex;
    justify-content: center;
    margin-top: 8%;
  }
  .filesee{
    padding-top: 10px;
    max-height: 230px;
    border:0.5px solid black;
    margin-top: 8%;
    width: 50%;
  }
  .filesees{
    padding-top: 10px;
    max-height: 230px;
    border:0.5px solid black;
    margin-top: 2%;
    width: 50%;
  }

 .ercitankuang_left{
    border:1px solid 	#9D9D9D;
    height:400px;
    flex: 1;
      word-break:keep-all;
      white-space:nowrap;
    overflow:auto;
    position:relative;
   }
  .ercitankuang_right{
    border:1px solid 	#9D9D9D;
    height:400px;
    flex: 1;
    overflow:auto;
  }
   .ercitankuang_content{
        flex: 0.1;
      text-align:center;
      height: 400px;
    }
   .alltext{
   margin: 20px;
   background-color: white;
   width: 95%;
   border:1px solid 	#9D9D9D;
   min-height: 900px;
   padding: 20px;
    position:relative;
 }
 .main {
     min-height: calc(100vh - 260px);
     width: 90%;
     margin: 0 15%;
   }
 .con {
     width: 95%;
     margin: 20px ;

   }
   .div_left{
     flex: 1;
     padding-left: 10%;
     margin-top: 10px;
   }
   .div_right{
     flex: 1;
     margin-top: 10px;
     min-height: 400px;
   }
 .center {
     text-align: center;
     margin-top: 20px;

   }
   .con-button {
     /* text-align: center; */
      position:absolute;
        right:10%;
        bottom:20%;

   }
   >>>.el-tree-node{
            white-space: normal;
            margin-top: 0.625rem;
          }
.over_tree{
      overflow: auto;
    }
    .over-tanchuang{
      overflow-y: auto;
      width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/view/company/train/Entry/EntryAdd.vue